import { render, staticRenderFns } from "./RightsIndicator.vue?vue&type=template&id=db05159a&scoped=true"
import script from "./RightsIndicator.vue?vue&type=script&lang=js"
export * from "./RightsIndicator.vue?vue&type=script&lang=js"
import style0 from "./RightsIndicator.vue?vue&type=style&index=0&id=db05159a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db05159a",
  null
  
)

export default component.exports